import { RoleDto, FindUserRolesQuery } from "../../api/AuthenticationApiClient";
import { Module, VuexModule, Action, Mutation } from "vuex-module-decorators";
import { UserStore } from "..";
import ApiFactory from "@/api/ApiFactory";

abstract class RoleTypes {
  static Admin: string = "Admin";
  static RiskProfileInput: string = "RiskProfileInput";
  static Advisor: string = "Advisor";
  static FactFindInput: string = "FactFindInput";
  static ActiveContact: string = "ActiveContact";
  static ExternalBroker: string = "ExternalBroker";
  static BrokerContact: string = "BrokerContact";
}

export interface IRoleState {
  userRoles: RoleDto[];
}

@Module({ name: "roleStore" })
export class RoleStoreModule extends VuexModule implements IRoleState {
  userRoles: RoleDto[] = [];

  get getUserRoles(): RoleDto[] | undefined {
    return this.userRoles ? this.userRoles : undefined;
  }

  get isAnAdmin(): boolean {
    let is: boolean = false;
    if (UserStore.loggedInUser) {
      this.userRoles.forEach(element => {
        if (element.name === "Admin") {
          is = true;
        }
      });
    }
    return is;
  }

  get isAnAdvisor(): boolean {
    let is: boolean = false;
    if (UserStore.loggedInUser) {
      this.userRoles.forEach(element => {
        if (element.name === "Advisor") {
          is = true;
        }
      });
    }
    return is;
  }

  get isFactFindUser(): boolean {
    let is: boolean = false;
    if (UserStore.loggedInUser) {
      this.userRoles.forEach(element => {
        if (element.name === "FactFindInput") {
          is = true;
          return;
        }
      });
    }
    return is;
  }

  get isRiskProfileUser(): boolean {
    return (
      UserStore.loggedInUser !== null &&
      this.userRoles.findIndex(x => x.name === RoleTypes.RiskProfileInput) > -1
    );
  }

  get isExternalBroker(): boolean {
    return (
      UserStore.loggedInUser !== null &&
      this.userRoles.findIndex(x => x.name === RoleTypes.ExternalBroker) > -1
    );
  }

  get isClient(): boolean {
    return (
      UserStore.loggedInUser !== null &&
      this.userRoles.findIndex(x => x.name === RoleTypes.ActiveContact) > -1
    );
  }
 get isBrokerClient(): boolean {
    return (
      UserStore.loggedInUser !== null &&
      this.userRoles.findIndex(x =>  x.name === RoleTypes.BrokerContact) > -1
    );
  }
  @Mutation
  private user_roles_loaded(roles: RoleDto[]) {
    this.userRoles = roles;
  }

  @Action
  async LoadUserRoles() {
    const apiClient = ApiFactory.CreateAuthClient();
    const query = new FindUserRolesQuery({
      userId: ""
    });
    const result = await apiClient.roles_UserRoles(query);
    if (result) {
      this.user_roles_loaded(result);
    }
  }

  @Action
  ClearUserRoles() {
    this.user_roles_loaded(new Array<RoleDto>());
  }
}
